<template>
  <div>
    <popover-right v-model="isShowConfess" width="750px" :closed="cancel">
      <h1 class="popover-right-title">{{type === 'new' ? '认筹申请' : '认筹编辑'}}</h1>
      <el-form class="pover-right-con c-detail-lock-con" :model="info" :rules="rules" ref="confessApplyRef">
        <div class="form-list-info">
          <div class="base-col">
            <div class="item item-show">
              <span class="label">商机：</span>
              <p class="result">{{baseInfo.business_code || info.business_code || '--'}}</p>
            </div>
            <div class="item item-show">
              <span class="label">客户：</span>
              <p class="result">{{baseInfo.customer_name || info.customer_name || '--'}}</p>
            </div>
            <div class="item item-show">
              <span class="label">项目：</span>
              <p class="result">{{baseInfo.project_name || info.project_name  || '--'}}</p>
            </div>
            <div class="item">
              <span class="label label-renchou">认筹金（元）：</span>
              <el-form-item prop="recognition_amount" class="lebel-con label-con-1">
                <el-input placeholder="请输入认筹金金额" v-model="info.recognition_amount" clearable />
              </el-form-item>
            </div>
            <div class="item">
              <span class="label">认筹日期：</span>
              <el-form-item prop="recognition_time" class="lebel-con label-con-1">
                <el-date-picker type="date" v-model="info.recognition_time" placeholder="请选择认筹日期" format="yyyy-MM-dd" value-format="timestamp" clearable></el-date-picker>
              </el-form-item>
            </div>
            <div class="item">
              <span class="label">优惠确认函：</span>
              <el-form-item prop="preferential_code" class="lebel-con label-con-1">
                <el-input placeholder="请输入优惠确认函" v-model="info.preferential_code" />
              </el-form-item>
            </div>
            <div class="item item-upload">
              <span class="label label-required">凭证：</span>
              <el-form-item prop="attachments" class="lebel-con">
                <el-button type="primary" class="upload-btn">上传凭证({{uploadImgList.length}}/10)</el-button>
                <input type="file" title="" class="upload-hidden-btn" id="confeeFileUpload" multiple @change="uploadChange" />
                <p class="desc">仅支持上传JPG/JPEG/PNG格式的图片，单张图片大小不超过10M</p>
              </el-form-item>
            </div>
            <div class="item upload-img-con">
              <template v-if="uploadImgList.length > 0">
                <span class="label"></span>
                <div class="lebel-con clearfix">
                  <div v-for="(img, i) in uploadImgList" :key="i" class="img-item">
                    <i class="iconfont iconshanchu" @click="remove(i)"></i>
                    <img :src="`${img}!watermark?imageView2/3/w/150/h/120/q/100`"  @click="toPreview(i)" />
                  </div>
                </div>
              </template>
            </div>
            <div class="item">
              <span class="label">备注：</span>
              <el-form-item prop="remark" class="lebel-con label-con-1">
                <el-input v-model="info.remark" type="textarea" :placeholder="`请输入备注，150字以内`" maxlength="150" :autosize="{ minRows: 5}" :show-word-limit="true"></el-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="label next-time">下次跟进时间：</span>
              <template v-if="type === 'show'">
                <p class="result" v-analysis-time="info.next_follow_up_time"></p>
              </template>
              <el-form-item prop="next_follow_up_time" class="lebel-con follow-input" v-else>
                <el-date-picker type="datetime" v-model="info.next_follow_up_time" placeholder="请选择下次跟进时间" format="yyyy-MM-dd HH:mm" value-format="timestamp" :picker-options="followNextOpt"></el-date-picker>
              </el-form-item>
            </div>
            <div class="item">
              <span class="label next-time">下次跟进说明：</span>
              <template v-if="type === 'show'">
                <p class="result" >{{info.next_follow_up_content || '--'}}</p>
              </template>
              <el-form-item prop="next_follow_up_content" class="lebel-con label-con-1" v-else>
                <el-input v-model="info.next_follow_up_content" type="textarea" placeholder="请输入下次跟进说明，20字以内" maxlength="20" :autosize="{ minRows: 2}" :show-word-limit="true"></el-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="label"></span>
              <div class="lebel-con">
                <div class="custom-btn">
                  <el-button type="primary" @click="save">提交</el-button>
                  <el-button type="info" @click="hide">取消</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </popover-right>
    <!--  凭证轮播图 -->
    <swipe :dataList="uploadImgList" :previewIndex="previewIndex" v-model="isShowPreview" type="noWater" />
  </div>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import {validateMoney} from '@/utils/validate';
import {getBussinessById} from '@/api/workflow';
import {applyRecongnition} from '@/api/custome';
import {imageBeforeUpload} from '@/plugins/cos';
import {getApproveRecognitionDetail, recognitionApproveEdit, getFailureApprove} from '@/api/approve';
import defaultSetting from '@/setting/index';
import Swipe from '@/components/swipe/index';
export default {
  name: 'ApplyConfess',
  components: {
    PopoverRight,
    Swipe
  },
  props: {
    value: String,
    approvalId: [Number, String],
    bussinessId: [Number, String],
    orderId: [Number, String],
    subscribeType: String,
    type: {
      type: String,
      default: 'new'
    },
    emitName: {
      type: String,
      default: ''
    },
    is_failure_stage: Boolean
  },
  data () {
    const validateFollowTime = (rule, value, callback) => {
      if (this.info.next_follow_up_content && !this.info.next_follow_up_time) {
        callback(new Error(`请选择下次跟进时间`));
      } else {
        callback();
      }
    }
    return {
      followNextOpt: {
        disabledDate: time => {
          return this.dealDisabledNextDate(time);
        }
      },
      info: {
        recognition_time: new Date().getTime(),
        recognition_amount: '',
        remark: '',
        attachments: ''
      },
      rules: {
        recognition_amount: [
          { validator: validateMoney, name: '认筹金', trigger: 'blur', isEmpty: true}
        ],
        preferential_code: [
          {max: 20, message: '请输入0-20长度字符的优惠确认函', trigger: 'blur'}
        ],
        attachments: [
          {required: true, message: '请上传凭证', trigger: 'change'}
        ],
        next_follow_up_time: [
          {validator: validateFollowTime, trigger: 'change'}
        ]
      },
      uploadImgList: [],
      isShowPreview: false,
      previewIndex: 0,
      baseInfo: {}
    }
  },
  computed: {
    isShowConfess () {
      return this.value === 'confess';
    }
  },
  mounted () {
    if (this.type !== 'new') {
      this.initApproveDetail();
    }else{
      if (this.is_failure_stage) {
        this.initFalureData();
      }
      this.initBussinessDetail();
    }
  },
  methods: {
    dealDisabledNextDate (time) {
      const timeAfter = time.getTime() < Date.now() - 8.64e7;
      let currentTime = new Date();
      currentTime = currentTime.setMonth(currentTime.getMonth() + 3)
      return timeAfter || time.getTime() > currentTime;
    },
    async initFalureData () {
      try {
        const res = await getFailureApprove({
          order_id: this.orderId
        })
        this.info = {
          ...this.info,
          ...res,
          recognition_time: !!res.recognition_time ? res.recognition_time*1000 : new Date().getTime()
        }
        if (res.attachment && res.attachment.length > 0) {
          this.info.attachments = 'attachments';
          this.uploadImgList = res.attachment.map(v => {
            const path = v['path'].replace(/\!watermark/g, '');
            return defaultSetting.sourceUrl + path;
          });
        }
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    cancel () {
      this.info = {
        recognition_time: new Date().getTime(),
        recognition_amount: '',
        remark: '',
        attachments: ''
      };
      this.uploadImgList = [];
      this.$refs.confessApplyRef.clearValidate();
      this.$emit('input', '');
    },
    hide () {
      this.cancel();
    },
    async initBussinessDetail () {
      try {
        const res = await getBussinessById(this.bussinessId);
        this.baseInfo = res;
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    async initApproveDetail () {
      try {
        const res = await getApproveRecognitionDetail(this.approvalId, {
        });
        this.info = {
          ...res.order,
          ...res.business,
          ...res.voucher,
          customer_name: res.customer.name,
          project_name: res.project.name,
          house_type_name: res.project.house_type_name,
          reason: res.voucher.remark,
          recognition_time: !!res.voucher.recognition_time ? res.voucher.recognition_time * 1000 : new Date().getTime(),
          id: res.order.id,
          next_follow_up_time: res.voucher.next_follow_up_time ? new Date(res.voucher.next_follow_up_time * 1000) : '',
          next_follow_up_content: res.voucher.next_follow_up_content || ''
        };
        if (res.attachment && res.attachment.length > 0) {
          this.info.attachments = 'attachments';
          this.uploadImgList = res.attachment.map(v => {
            const path = v['path'].replace(/\!watermark/g, '');
            return defaultSetting.sourceUrl + path;
          });
        }
      } catch (error) {
        this.$message.error(error.msg || '获取审批详情出现错误');
      }
    },
    save () {
      this.$refs.confessApplyRef && this.$refs.confessApplyRef.validate(async (valid) => {
        if (!valid) return null;
        try {
          const params = {
            ...this.info,
            next_follow_up_time: this.info.next_follow_up_time ? parseInt(this.info.next_follow_up_time / 1000) : ''
          }
          if (params.recognition_time) {
            params.recognition_time = parseInt(this.info.recognition_time / 1000)
          } else {
            params.recognition_time = 0;
          }
          if (this.subscribeType ==='order') {
            params['order_id'] = this.orderId;
          } else if (this.subscribeType === 'bussiness') {
            params['business_id'] = this.bussinessId;
          }
          if (this.uploadImgList.length > 0) {
            params.attachments = this.uploadImgList.map(v => {
              const imgList = v.split('/');
              return imgList.filter((img, i) => {
                if (i >2) return img;
                return false;
              }).join('/');
            }).join('||');
          }
          if (this.type === 'new') {
            await applyRecongnition(params);
          } else {
            await recognitionApproveEdit(this.approvalId, params);
          }
          this.$message.success('认筹操作提交成功!');
          this.hide();
          this.$parent.initList && this.$parent.initList();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试')
        }
      })
    },
    uploadChange (e) {
      imageBeforeUpload(e.target.files, this.uploadCall, {length : this.uploadImgList.length});
    },
    uploadCall (list = [], msg) {
      document.getElementById("confeeFileUpload").value = '';
      if (msg) {
        this.$message.error(msg);
      }
      this.uploadImgList.push(...(list.map(v => `https://${v}`)));
      if (this.uploadImgList.length > 0) {
        this.info = Object.assign({}, this.info, {
          attachments: 'attachments'
        })
        this.$nextTick(() => {
          this.$refs.confessApplyRef.validateField('attachments');
        })
      }
    },
    remove (index) {
      this.uploadImgList.splice(index, 1);
      if (this.uploadImgList.length <= 0) {
        this.info = Object.assign({}, this.info, {
          attachments: ''
        })
        this.$nextTick(() => {
          this.$refs.confessApplyRef.validateField('attachments');
        })
      }
    },
    toPreview (key) {
      this.isShowPreview = true;
      this.previewIndex = key;
    }
  }
}
</script>
<style scoped lang="less">
.c-detail-lock-con{
  .item .label{
    width: 100px;
    text-align: right;
  }
  .item .label-lock{
    margin-left: -23px;
    width: 115px;
  }
}
.label-renchou{
  min-width: 100px !important;
  margin-left: -10px !important;
}
</style>
